import { Layout as BaseLayout, Spin } from "antd";
import { FC, Suspense } from "react";
import { Outlet } from "react-router-dom";
// import PrivateHeader from './PrivateHeader';
import Sider from "antd/es/layout/Sider";
import { Content } from "antd/es/layout/layout";
import { useSelector } from "react-redux";
import LeftMenu from "./LeftMenu/LeftMenu";
// import { RootState } from '../redux/store';
import { useLocation } from 'react-router-dom';
const PrivateLayout: FC = () => {
  //   const { isNavbarVisible } = useSelector((state: RootState) => state.navbar);
  const isNavbarVisible = true;
  const location = useLocation();
  const isCrmPage = location.pathname.startsWith('/crm');
  return (
    <BaseLayout className="app">
      {/* <PrivateHeader /> */}
      <BaseLayout className="privateContent">
        {isCrmPage ? (
          ' '
        ) : (
          <Sider width={'30%'} className={`sidebar ${!isNavbarVisible ? 'hiddenSidebar' : undefined}`}>
            <LeftMenu />
          </Sider>
        )}

        <BaseLayout className="privateCenter">
          <Content>
            <Suspense fallback={<Spin size={'large'} />}>
              <Outlet />
            </Suspense>
          </Content>
        </BaseLayout>
      </BaseLayout>
    </BaseLayout>
  );
};

export default PrivateLayout;
